import React from "react";

interface Props {
  activeColor: string;
}

const HighIntentRateIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="20" fill="#D1FAE5" />

      <circle cx="24" cy="24" r="10" stroke="#10B981" strokeWidth="2" />

      <circle cx="24" cy="24" r="5" stroke="#10B981" strokeWidth="2" />

      <circle cx="24" cy="24" r="2" fill="#10B981" />

      <path
        d="M24 24L30 18"
        stroke="#10B981"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M28.5 18H30V19.5"
        stroke="#10B981"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HighIntentRateIcon;
